import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-b-end-crm",
  "use": "icon-soc-mall-b-end-crm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-b-end-crm\">\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <rect x=\"160\" y=\"200\" width=\"704\" height=\"624\" rx=\"48\" />\r\n    <path d=\"M260 360h504M260 480h360M260 600h420\" />\r\n    <circle cx=\"720\" cy=\"600\" r=\"56\" />\r\n    <path d=\"M696 600l16 16 36-40\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-b-end-crm.svg
// module id = r6GE
// module chunks = 534